import { AbstractControl, ValidatorFn } from '@angular/forms';

export function noSpacesValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const hasSpaces = control.value ? control.value.includes(' ') : false;
    return hasSpaces ? { 'noSpaces': true } : null;
  };
}
